import {useContext, useEffect, useState} from "react";
import { UserContext } from '../Context/UserContext'
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import "../styles/checkoutForm.css"

function CheckoutForm({onDataChange, selectedSubTyp}) {
    const {state, dispatch} = useContext(UserContext);
    //console.log('user', state.user)
    const stripe = useStripe()
	const elements = useElements()
    const [clientSecret, setClientSecret] = useState('')
    const [errorsState, setErrorsState] = useState([])
    const [isProcessing, setIsProcessing] = useState(false)
    const [total, setTotal] = useState(0)

    const [checkoutFormData, setCheckoutFormData] = useState({
        email: state.user.email,
        sub_type: selectedSubTyp || "",
    })

    function handleChangeType(e) {
        setErrorsState([])
        const selectedSubType = e.target.value
        onDataChange(e.target.value)
        setCheckoutFormData(prevState => ({
            ...prevState,
            sub_type: selectedSubType
        }))
        let newTotal = 0;
        switch (selectedSubType) {
            case 'Season Pass':
                newTotal = 10;
                break;
            // case 'Monthly Pass':
            //     newTotal = 20;
            //     break;
            case 'Day Pass':
                newTotal = 3;
                break;
            default:
                break;
        }
        setTotal(newTotal)
    }

    function handleChangeEmail(e) {
        setCheckoutFormData(prevState => ({
            ...prevState,
            email: e.target.value
        }))
    }

    function handleSubmit(e) {
        e.preventDefault()
        setErrorsState([])
        if (!stripe || !elements) {
            return
        }

        if (checkoutFormData.sub_type === '') {
            setErrorsState('Must select a subscription type from the dropdown');
            return;
        }

        setIsProcessing(true)

        elements.submit().then(result => {
            //console.log('result', result)
            if (result.error) {
                setIsProcessing(false);
                setErrorsState('Error submitting payment details:', result.error);
                return;
            }
            if (checkoutFormData.sub_type === "Monthly Pass") {
                fetch('/customers', {
                    method: "POST",
                    headers:  {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        user_id: state.user.id,
                        sub_type: checkoutFormData.sub_type,
                        email: checkoutFormData.email,
                    })
                })
                .then(res => res.json())
                .then(customerObj => {
                    //customerObj successfully returns customer name and stripeCustomerID created in customers controller and saved to customer model
                    return fetch('/payment_intents/create_stripe_sub', {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            user_id: state.user.id,
                            sub_type: checkoutFormData.sub_type,
                            email: checkoutFormData.email,
                            customer_id: customerObj.id
                        })
                    })
                    .then(res => {
                        if (!res.ok) {
                            throw new Error(`status: ${res.status}`)
                        }
                        if (res.status === 204 || res.headers.get("content-length") === "0") {
                            return {}; // Return empty object if no content
                        }
                        return res.json()
                    })
                    .then(stripeSub => {
                        console.log('stripeSub', stripeSub)
                        if (stripeSub.message) {
                            alert(stripeSub.message)
                        }
                        else {
                            //console.log('stripeSub client secret', stripeSub.client_secret)
                            setClientSecret(stripeSub.client_secret)
                        }
                    })
                })
            }
            else {
                fetch('/payment_intents', {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        user_id: state.user.id,
                        sub_type: checkoutFormData.sub_type,
                        email: checkoutFormData.email,
                    })
                })
                .then(res => res.json())
                .then(paymentIntent => {
                    setClientSecret(paymentIntent.client_secret)
                })
            }
        })
    }

    useEffect(() => {
        if (clientSecret && stripe && elements) {
            const isSetupIntent = clientSecret.startsWith("seti_") // Check for SetupIntent prefix

            if (isSetupIntent) {
                stripe.confirmSetup({
                    elements,
                    clientSecret,
                    confirmParams: {
                        return_url: `${window.location.origin}/payment-successful`
                    }
                })
                .then((data) => {
                    if (data.error) {
                        setIsProcessing(false)
                        setErrorsState(data.error.message)
                    } else if (data.setupIntent.status === "succeeded") {
                        dispatch({ type: 'setPaymentStatus', payload: true })
                    }
                })
            }
            else {
                stripe.confirmPayment({
                    elements,
                    clientSecret,
                    confirmParams: {
                        return_url: `${window.location.origin}/payment-successful`
                    }
                })
                .then((data) => {
                    //console.log('data after confirmPayment', data)
                    if (data.error) {
                        setIsProcessing(false)
                        setErrorsState(data.error.message)
                    }
                    else if (data.paymentIntent.status === "succeeded") {
                        dispatch({type: 'setPaymentStatus', payload: true})
                        //console.log('new sub user', state.user)
                    }
                })
            }
        }
    }, [clientSecret])

    return (
        <div className="checkoutFormContainer">
            <form className="paymentForm" onSubmit={handleSubmit}>
                <label>Email: </label>
                <input id="email" type="text" value={checkoutFormData.email} onChange={handleChangeEmail} placeholder="Enter email address" />
                <br />
                <label>
                    Choose a Subscription Type:
                    <select value={checkoutFormData.sub_type} onChange={handleChangeType}>
                        <option value="">Select...</option>
                        <option value="Season Pass">Season Pass</option>
                        {/* <option value="Monthly Pass">Monthly Pass</option> */}
                        <option value="Day Pass">Day Pass</option>
                    </select>
                </label>
                <br />
                <label>Total: </label>
                <input id="totalInput" type="text" value={`$${total}`} onChange={handleChangeType} />
                <PaymentElement className="paymentElement"/>
                <h3>All Sales Final. No Refunds</h3>
                {checkoutFormData.sub_type === "Monthly Pass" && (<p className="monthlyRenewReminder">Monthly passes will automatically renew each month</p>)}
                <button className="submitPaymentButton" disabled={isProcessing} type="submit">{isProcessing ? "Processing..." : "Subscribe"}</button>
            </form>
            {errorsState.length > 0 && (<p style={{color: "red"}}>{errorsState}</p>)}
        </div>
    )
}

export default CheckoutForm